<template>
  <div v-if="content.target" :class="content.target.size?.sm?.fullWidth ? 'w-full' : 'w-fit'">
    <cms-shared-button ref="elementRef" v-bind="content.target" @click="handleClick" />
  </div>
</template>

<script lang="ts" setup>
import type { CtaButtonContent } from '#types/components/cms/cta-button'
import { ParentPromotionTrackingKey } from '#content/contexts/promotionTracking'

const { content } = defineProps<{ content: CtaButtonContent }>()

const { parentPromotionName, parentHandlePromotionClick } = inject(ParentPromotionTrackingKey, {})

const {
  elementRef,
  handlePromotionClick
} = usePromotionTracking(content.promotionTracking, content.name, parentPromotionName)

const handleClick = () => {
  handlePromotionClick()
  parentHandlePromotionClick && parentHandlePromotionClick()
}
</script>
